import React from 'react';
import { SourceInfoButton } from '../Components/SourceInfoButton';
import { useDatasourceInfo } from './useDatasourceInfo';

export const DatasourceInfo = ({ datasourceId }: { datasourceId: number }) => {
  const { name, path } = useDatasourceInfo(datasourceId);

  return <SourceInfoButton sourceName={name} sourcePath={path} />;
};
